import { useLang } from "../i18n/LanguageContext";
import { GiMoonOrbit } from "react-icons/gi";

const FOOTER_LINKS = {
  pl: [
    { label: "Polityka prywatności", href: "#/polityka-prywatnosci" },
    { label: "RODO", href: "#/rodo" },
    { label: "Regulamin", href: "#/regulamin" },
    { label: "Kontakt", href: "#/kontakt" },
  ],
  en: [
    { label: "Privacy", href: "#/polityka-prywatnosci" },
    { label: "GDPR", href: "#/rodo" },
    { label: "Terms", href: "#/regulamin" },
    { label: "Contact", href: "#/kontakt" },
  ],
};

export const Footer = () => {
  const { lang, t } = useLang();
  const links = FOOTER_LINKS[lang] || FOOTER_LINKS.pl;
  return <footer className="bg-ink-deep text-parchment py-20" data-testid="site-footer"><div className="max-w-5xl mx-auto px-6 md:px-10 text-center"><div className="flex justify-center text-gold-muted"><GiMoonOrbit className="text-3xl" /></div><div className="font-accent text-base tracking-[0.4em] mt-4">MORFEUSZ</div><div className="font-heading italic text-lg text-parchment/60 -mt-1">dreams</div><p className="font-body italic text-sm text-parchment/50 mt-6">{t.footer.tagline}</p><div className="divider-ornate mt-10 max-w-xs mx-auto opacity-40">●</div><ul className="mt-8 flex flex-wrap justify-center gap-x-10 gap-y-3">{links.map((link, i) => <li key={link.href}><a href={link.href} className="font-accent text-[11px] uppercase tracking-[0.25em] text-parchment/60 hover:text-gold-light transition-colors" data-testid={`footer-link-${i}`}>{link.label}</a></li>)}</ul><div className="mt-10 font-body text-xs text-parchment/40">{t.footer.copyright}</div></div></footer>;
};
